



















































































import Vue from "vue";
export default Vue.extend({
  props: {
    fromDate: { type: String },
    toDate: { type: String },
    setFromDate: { type: Function },
    setToDate: { type: Function },
    maxDate: { type: String }
  },
  data() {
    const menuFromDate = false;
    const menuToDate = false;
    const defaultFromDate = this.fromDate;
    const defaultToDate = this.toDate;
    return { menuFromDate, menuToDate, defaultFromDate, defaultToDate };
  },
  methods: {},
  mounted() {
    this.setFromDate(this.fromDate, true);
    this.setToDate(this.toDate, true);
  }
});
